module.exports = __webpack_public_path__ + "img/feat_3.6e4c871f.png";